import Container from 'elements/Container'
import React from 'react'
import { COACHING_LIST } from './CoachingList'
import {
  CoachingWrapper,
  CoachingTitle,
  CoachingExplanation,
  ButtonWrap,
  CoachingButton,
  CoachingHeaderTitle,
  ExplainationWrapper
} from './styled'
import { useToggleContactUsModal } from 'state/application/hooks'
import ContactModal from '../../components/ContactModal'

const Coaching = (): JSX.Element => {
  const toggleContactUsModal = useToggleContactUsModal()

  return (
    <Container>
      <CoachingHeaderTitle>Accelerator</CoachingHeaderTitle>
      {COACHING_LIST.map((elm, idx) => {
        return (
          <CoachingWrapper key={idx}>
            <ExplainationWrapper>
              <CoachingTitle>{elm.name}</CoachingTitle>
              <CoachingExplanation>{elm.description}</CoachingExplanation>
            </ExplainationWrapper>
            <ButtonWrap>
              <CoachingButton onClick={toggleContactUsModal}>Contact Us</CoachingButton>
            </ButtonWrap>
          </CoachingWrapper>
        )
      })}
      <ContactModal />
    </Container>
  )
}

export default Coaching
